import { ObjectMapper } from 'json-object-mapper';
import { Model, OptionModel } from '../model';
import { IModel } from '../IModel';

export class SalaryRangeModel extends Model implements IModel<SalaryRangeModel> {
 foreingId: string = '';
 amount: number = 0;
 salaryScaleId: string | undefined = undefined;
  
  static create(input: any): SalaryRangeModel {
    return ObjectMapper.deserialize<SalaryRangeModel>(SalaryRangeModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
